import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

var packagingSwiper = new Swiper(".section2 .swiper", {
    centeredSlides: true,
    loop: true,
    speed:5000,
    autoplay: {
        delay: 0,
        stopOnLastSlide: false,
    	disableOnInteraction: false,
	},
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 2.6,
        spaceBetween: '1.983%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        spaceBetween: 0,
      }
    } 
});


$(".section3 ul li .title").click(function() {
     let $dl = $(this).parent();
    if($dl.hasClass("active")){
        $dl.removeClass("active");
    }else{
        $(".section3 ul li").removeClass("active");
        $dl.addClass("active");
    }
})

$(".join-btn").click(function() {
    $(".join-pop").css('display','flex');
})
$(".join-pop .model").click(function() {
    $(".join-pop").hide();
})
$(".join-pop .out").click(function() {
    $(".join-pop").hide();
})